import { render, staticRenderFns } from "./UserWizard.vue?vue&type=template&id=7afb485a&scoped=true"
import script from "./UserWizard.vue?vue&type=script&lang=js"
export * from "./UserWizard.vue?vue&type=script&lang=js"
import style0 from "./UserWizard.vue?vue&type=style&index=0&id=7afb485a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afb485a",
  null
  
)

export default component.exports